const sections = document.querySelectorAll('section.parallax');

class Parallax {
    constructor(section) {
        this.root = section;
        if (!this.root) return;

        this.init();
    }

    init() {
        this.fastGallery = this.root.querySelector('[js-fast-gallery]');
        this.slowGallery = this.root.querySelector('[js-slow-gallery]');

        this.events();
    }

    events() {
        if (this.fastGallery) {
            this.handleScroll();
            window.addEventListener('scroll', this.handleScroll.bind(this));
        }
    }

    handleScroll() {
        const rect = this.root.getBoundingClientRect();
        const viewportH = window.innerHeight;

        const sectionHeight = this.root.offsetHeight;

        const start = viewportH; // 100vh
        const end = sectionHeight;

        const scrolled = viewportH - rect.top;

        const progress = (scrolled - start) / (end - start);

        const percent = progress * 100;

        this.handleGalleryTransform(percent, this.fastGallery, 44, 100);
        if (this.slowGallery) {
            this.handleGalleryTransform(percent, this.slowGallery, 33, 76);
        }
    }

    handleGalleryTransform(
        percent,
        targetGallery,
        maxTransform = 100,
        mobileTransform = 100
    ) {
        const clamped = Math.min(Math.max(percent, 0), 100);

        const translate =
            -(clamped / 100) *
            (window.innerWidth >= 1024 ? maxTransform : mobileTransform);

        targetGallery.style.transform = `translate3d(0px, ${translate}%, 0px)`;
    }
}

if (sections.length > 0) {
    sections.forEach(section => {
        new Parallax(section);
    });
}
